<div class="statements-wrapper" *ngIf="statements">

	<ng-container *ngIf="!statements.success">
		<div class="no-statement-msg">
			<mat-icon>description</mat-icon>
			<p>No statements found for this customer.</p>
		</div>
	</ng-container>

	<ng-container *ngIf="statements.success">
		<!-- Controls Panel -->
		<div class="controls-panel">
			<div class="controls-row">
				<mat-form-field appearance="outline" class="email-field">
					<mat-label>Email Address</mat-label>
					<mat-icon matPrefix>email</mat-icon>
					<input matInput [formControl]="email" [disabled]="sending">
				</mat-form-field>

				<mat-form-field appearance="outline" class="date-field">
					<mat-label>Aging Date</mat-label>
					<input matInput [matDatepicker]="picker" [formControl]="todate" [disabled]="sending">
					<mat-datepicker-toggle matSuffix [for]="picker" [disabled]="sending"></mat-datepicker-toggle>
					<mat-datepicker #picker></mat-datepicker>
				</mat-form-field>

				<div class="action-buttons">
					<a mat-stroked-button color="primary" [href]="statementLink" target="_blank" class="pdf-btn">
						<mat-icon>picture_as_pdf</mat-icon>
						PDF
					</a>
					<button mat-raised-button color="accent" (click)="emailStatement()" [disabled]="sending || loading" class="send-btn">
						<mat-icon>send</mat-icon>
						{{ sending ? 'Sending...' : 'Send' }}
					</button>
				</div>
			</div>

			<!-- Email Editor -->
			<div class="editor-section" *ngIf="!loading && isLayoutReady">
				<div class="main-container">
					<div class="editor-container editor-container_classic-editor" #editorContainerElement>
						<div class="editor-container__editor">
							<div #editorElement>
								<ckeditor [formControl]="emailMessage" [editor]="Editor" [config]="ckconfig" [disabled]="sending" />
							</div>
						</div>
					</div>
				</div>
			</div>
		</div>

		<!-- Loading -->
		<div class="loading-state" *ngIf="loading">
			<svg class="spinner" width="40px" height="40px" viewBox="0 0 66 66" xmlns="http://www.w3.org/2000/svg">
				<circle class="path" fill="none" stroke-width="6" stroke-linecap="round" cx="33" cy="33" r="30"></circle>
			</svg>
			<span>Loading statement...</span>
		</div>

		<!-- Statement Document Preview -->
		<div class="statement-preview-wrapper" *ngIf="!loading">
			<div class="statement-document"
				 #statementContent
				 [innerHTML]="statements.content | safeHtml">
			</div>
		</div>
	</ng-container>
</div>
<div class="loading-state" *ngIf="loading">
	<svg class="spinner" width="40px" height="40px" viewBox="0 0 66 66" xmlns="http://www.w3.org/2000/svg">
		<circle class="path" fill="none" stroke-width="6" stroke-linecap="round" cx="33" cy="33" r="30"></circle>
	</svg>
	<span>Loading statement...</span>
</div>
